<template>
    <div class="mmf-pagination row mt-2" v-if="totalRows > 0">
        <div class="col-lg-6">
            <label class="control-label">{{ label }}</label>
            <div>
                <b-form-select variant="primary" v-model="mmfPerPage" style="width:max-content;" :options="optionsPerPage" @change="onChangeSelect($event)" />
                <label class="control-label ml-1" >{{ $t("lbl.pagination.rowsPerPage") }}</label>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="float-lg-right">
                <b-pagination align="right" style="margin-top: 0;" :total-rows="totalRows" :per-page="mmfPerPage" v-model="currentPage" @change="onChangePage($event)">
                </b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "mmf-pagination",
    props: {
        totalRows: Number,
        perPage: Number,
        currentPage: Number,
        entity: String
    },
    data() {
        return {
            optionsPerPage: [
                { value: 5, text: '5' },
                { value: 15, text: '15' },
                { value: 25, text: '25' },
                { value: 50, text: '50' },
                { value: 100, text: '100' }
            ]
        }
    },
    computed: {
        label: function() {
            var lbl = this.$t("lbl.pagination.status", {0: this.minRange, 1: this.maxRange, 2: this.totalRows});
            return lbl;
        },
        currentPageDec: function() {
            return this.currentPage - 1;
        },
        minRange: function() {
            return this.perPage * (this.currentPage - 1) + 1;
        },
        maxRange: function() {
            var maxValue = this.perPage * this.currentPage;
            var result = (maxValue > this.totalRows ? this.totalRows : maxValue);
            return result;
        },
        mmfPerPage:{
            get(){
                return this.perPage
            },
            set(value){
                this.$emit('change:perpage', value)
            }
        }
    },
    methods: {
        onChangeSelect(evt) {
            this.$emit('change:perpage', evt);
            this.loadRows();
        },
        onChangePage(evt) {
            this.$emit('change:page', evt);
            this.loadRows();
        },
        loadRows() {
            this.MMFLoadRowsSearch(this.entity);
        },
        ...mapActions("base", ["MMFLoadRowsSearch"])
    }
}
</script>